import React from 'react';

function MapContainer(props: any) {
    return <div className="map-container h-100" id="map-container-id"></div>
}

export default React.memo(MapContainer)